/* eslint-disable no-shadow */
import React from 'react';
// eslint-disable-next-line import/no-cycle
import TrustedShops from './scripts/TrustedShops';
export var CustomScriptTestIds;
(function (CustomScriptTestIds) {
    CustomScriptTestIds["CustomScript"] = "script__content";
    CustomScriptTestIds["TrustedShopsScript"] = "script__trustedShops";
    CustomScriptTestIds["DefaultScript"] = "script__default";
})(CustomScriptTestIds || (CustomScriptTestIds = {}));
export var Types;
(function (Types) {
    Types["TrustedShops"] = "trustedShops";
})(Types || (Types = {}));
var CustomScript = function (_a) {
    var contentData = _a.contentData;
    var scriptType = contentData.field_script_type, externalApiKey = contentData.field_api_key;
    switch (scriptType) {
        case Types.TrustedShops:
            return React.createElement(TrustedShops, { externalApiKey: externalApiKey });
        default:
            return React.createElement("div", { "data-testid": CustomScriptTestIds.DefaultScript });
    }
};
export default CustomScript;
//# sourceMappingURL=index.js.map